import { render, staticRenderFns } from "./manifest-payment-table.vue?vue&type=template&id=2701ff4a"
import script from "./manifest-payment-table.vue?vue&type=script&lang=js"
export * from "./manifest-payment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports